import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Scope wrapper for migrated shadcn/ui subtrees.
 *
 * Tailwind's preflight is disabled globally (so MUI pages are untouched); the
 * scoped base reset in globals.css keys off the `tw` class. EVERY page or region
 * rebuilt in shadcn must be wrapped in this component so its Tailwind utilities
 * (borders, box-sizing, button resets) behave. Also paints the shadcn background
 * + foreground tokens so the region is self-contained in light and dark.
 */
export function Shadcn({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('tw text-foreground', className)} {...props} />;
}
